/**
 * orga-app-api - veranstaltungen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VeranstaltungKopfdatenFeldReportModel { 
    sort_number?: number;
    level?: number;
    ist_gruppe?: boolean;
    veranstaltung_id?: string;
    text: string;
    wert?: string;
    gruppe?: string;
}

